import {Avatar} from 'antd'
import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {nest} from 'recompose'
import {EntityContext, EntityProvider} from 'views/AppLocals/EntityList'
import {ContextActionTypes, ItemContextMenu,} from 'views/AppLocals/factory/createContextMenu'
import {NullAsDefault, renderIf} from 'views/Shared'
import {renderIfElse} from '../../../Shared'
import Translate from "../../../../modules/local/Translate";
import {PiArrowRightBold, PiGearSixFill} from "react-icons/pi";
import {HiOutlineLink} from "react-icons/hi2";
import {getEventTypeTitle} from "../../../Event/components/EventOverviewSetting";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {formatDate, parseDayjs} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";
import {BsCalendar2Date, BsFillCalendar2DateFill, BsPinMapFill} from "react-icons/bs";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {ItemInfoWithIcon} from "../../../../components/common/ItemInfoWithIcon";
import {ItemInformation} from "../../../../components/common/ItemInformation";

export const renderEventCompactItem = ({isLg, translate: t, handleAction = NullAsDefault, renderContextMenu = NullAsDefault,}) => (item, index) => {
    const is_expired = !!item?.is_expired

    return (
        <div
            key={index}
            className={classNames(
                "p-4 custom-item-render transition-all duration-300 relative list-item",
                is_expired && 'opacity-60'
            )}>
            <div className="flex items-start gap-3">
                {isLg && (
                    <Avatar
                        size={40}
                        src={_.get(item, 'owner.avatar')}
                        icon={<BsCalendar2Date size={20} className="text-green-500"/>}
                        className={classNames("mt-1 flex flex-center rounded-lg", is_expired ? 'background-200' : 'bg-green-50')}
                    />
                )}
                <div className="flex flex-col flex-1 min-w-0">
                    <Link
                        to={getLinkToDetail(item)}
                        className={classNames(
                            "font-bold text-base tracking-wide no-underline",
                            is_expired && 'line-through'
                        )}>
                        {getTitle(item)}
                    </Link>
                    <div className="mt-1 flex items-center gap-1.5 flex-wrap">
                        <span
                            style={{ padding: '0.15rem 0.5rem' }}
                            className="w-fit font-medium bg-blue-100 rounded-full text-xs text-blue-600 tracking-wider leading-snug">
                            {t(_.get(item, 'event_type'))}
                        </span>
                        {is_expired && (
                            <span
                                style={{ padding: '0.15rem 0.5rem' }}
                                className="w-fit font-bold uppercase bg-slate-100 rounded-full text-2xs text-gray-500 tracking-widest leading-snug">
                                {t('expired')}
                            </span>
                        )}
                    </div>
                    <div className="my-2 border-b border-color-50"/>
                    <div className="flex flex-col flex-1 gap-1">
                        <ItemInformation
                            label="time" showIcon={true} className="text-xs italic tracking-wider"
                            value={formatSimplifyDate(_.get(item, 'time_open'), 'fullTime')}
                        />
                        {item?.external_link && (
                            <ItemInformation
                                label="link" showIcon={true} className="text-xs italic tracking-wider"
                                value={
                                    <Link
                                        to={item?.external_link}
                                        className="font-medium tracking-wide no-underline">
                                        {item?.external_link}
                                    </Link>
                                }
                            />
                        )}
                        <ItemInformation
                            label="location" showIcon={true} className="text-xs italic tracking-wider"
                            value={item?.location_name}
                        />
                    </div>
                    {item?.description && (
                        <div className="mt-1 text-color-300 tracking-wider">
                            {item?.description}
                        </div>
                    )}
                    {_.isFunction(renderContextMenu) && (
                        <div className="absolute right-5 top-5 contextIcon">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

const ItemHeader = ({
                        impactCategories,
                        withMenuOptions = (item) =>
                            [
                                {
                                    key: ContextActionTypes.COPY,
                                    label: 'copy path',
                                    icon: <HiOutlineLink className="text-blue-500"/>,
                                },
                                !!_.get(item, 'edit', false)
                                    ? {
                                        icon: <PiGearSixFill className="text-color-400"/>,
                                        key: ContextActionTypes.SETTINGS,
                                        label: 'setting',
                                    }
                                    : undefined,
                            ].filter((e) => !_.isUndefined(e)),
                    }) => (
    <div className="absolute top-5 right-5 contextIcon">
        <EntityContext.Consumer>
            {({item, handleAction}) => (
                <ItemContextMenu
                    item={item}
                    onMenuSelect={handleAction}
                    items={withMenuOptions(item)}
                />
            )}
        </EntityContext.Consumer>
    </div>
)

const DefaultHyperLink = ({title, pathname, className, onClick = NullAsDefault}) => {
    const t = useTranslate()
    return (
        <Link
            to={pathname}
            onClick={onClick}
            className={classNames(
                'font-bold text-lg text-color-000 no-underline max-lines-1 leading-snug ',
                className
            )}>
            {t(title || 'no title')}
        </Link>
    )
}

export function renderIntervalWeekly(value) {
    let label = ''
    switch (value) {
        case '1000000':
            label = 'monday'
            break
        case '0100000':
            label = 'tuesday'
            break
        case '0010000':
            label = 'wednesday'
            break
        case '0001000':
            label = 'thursday'
            break
        case '0000100':
            label = 'friday'
            break
        case '0000010':
            label = 'saturday'
            break
        case '0000001':
            label = 'saturday'
            break
        default :
            label = null
            break
    }
    return label ? label : null
}

export function renderInterval(value, viewOnly = false) {
    let label
    switch (value) {
        case 'D':
            label = 'daily'
            break
        case 'W':
            label = 'weekly'
            break
        case 'M':
            label = 'monthly'
            break
        default :
            if (viewOnly) return "";
            label = 'do not repeat'
            break
    }
    return (
        <Translate>
            {(t) => t(label)}
        </Translate>
    )
}

const EventItem = ({item}) => {
    const t = useTranslate()
    const history = useHistory()
    const {isSm} = useContext(LayoutContext)

    const {time_open, time_close, location_name, description, external_link, event_type, interval_type, interval_daily, is_expired} = item ?? {}
    const openTime = time_open ? parseDayjs(time_open) : null;

    const renderLabelTime = (value) => {
        let label
        if (interval_type === 'D') {
            label = formatDate(value, 'HH:mm')
        } else if (interval_type === 'W') {
            label = [
                formatDate(value, 'HH:mm'),
                t(renderIntervalWeekly(interval_daily))
            ].join(' - ')
        } else if (interval_type === 'M') {
            label = [
                formatDate(value, 'HH:mm'),
                '-',
                t('date'),
                formatDate(value, 'DD')
            ].join(' ')
        } else {
            label = formatDate(value, 'DD MMMM, YYYY')
        }
        return (
            <span className="flex items-center gap-3">
                {label}
                {renderIf(
                    _.get(item, 'time_close'),
                    <span className="flex items-center font-semibold">
                        <PiArrowRightBold className="text-color-500 mr-2"/>
                        {formatDate(time_close, 'DD MMMM, YYYY')}
                    </span>
                )}
                {interval_type !== 'N' && (
                    <span className="ml-2 text-green-600 italic">
                        ( {renderInterval(interval_type, true)} )
                    </span>
                )}
            </span>
        )
    }

    return (
        <div className="px-3 py-2 border border-color-50 background shadow-md rounded-xl hover:scale-3xs custom-item-render relative">
            <div className="flex flex-col">
                <div className="mb-2 pb-2 border-b">
                    <DefaultHyperLink
                        title={getTitle(item)}
                        pathname={getLinkToDetail(item)}
                    />
                    <div className="flex items-center justify-between gap-3">
                        <span className="text-xs text-indigo-500 tracking-wider leading-snug italic">
                            {t(getEventTypeTitle(event_type))}
                        </span>
                        <div className="font-semibold text-xs italic ">
                            {is_expired === true ? (
                                <span className="text-red-600">{t('close')}</span>
                            ) : openTime && openTime.isValid() && openTime.isAfter(dayjs()) ? (
                                <span className="text-green-700">{t('upcoming')}</span>
                            ) : (
                                <span className="text-blue-700">{t('opening')}</span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex flex-col flex-1 gap-1">
                    {renderIf(
                        time_open,
                        <ItemInfoWithIcon
                            icon={<BsFillCalendar2DateFill size={12} className="mx-1 text-green-500"/>}
                            value={renderLabelTime(time_open)}
                            className="flex items-center text-sm italic tracking-wide"/>
                    )}
                    {renderIfElse(
                        event_type === "webinar",
                        <ItemInfoWithIcon
                            icon={<BsPinMapFill size={12} className="mx-1 text-green-500"/>}
                            value={
                                <a href={external_link} target="_blank" className="no-underline">
                                    {external_link}
                                </a>
                            }
                            className="flex items-center text-sm italic tracking-wide"/>,
                        <ItemInfoWithIcon
                            icon={<BsPinMapFill size={12} className="mx-1 text-green-500"/>}
                            value={location_name}
                            className="flex items-center text-sm italic tracking-wide"
                        />
                    )}
                </div>
                <div className="mt-2 text-sm text-color-300 tracking-wider whitespace-pre-line">
                    {description}
                </div>
            </div>
            <ItemHeader/>
        </div>
    )
}

export default nest(EntityProvider, EventItem)
